module.exports = __webpack_public_path__ + "img/red-packets.5f46f82b.png";